<template>
  <div :id="localeClass" class="platform__pc" :class="{ 'no-min-width': isNewcomponentMlz }">
    <USHeader v-if="showUsHeader" />
    <NewUSHeader v-else-if="showNewUsHeader" />
    <Header v-else />
    <template v-if="$nuxt.isOffline">
      <div class="network-offline-container">
        <Exception tip-text="Loading failed, please check your connection." placeholder-class-name="system-error-img" :show-retry-btn="true" @retry="reload" />
      </div>
    </template>
    <template v-else>
      <!-- 使用个人中心layout的所有页面均认为需要登录 -->
      <template v-if="isLogin">
        <div class="personal-center-body-wrapper">
          <div class="wrapper flex-wrapper">
            <SideNavigationBar class="side-nav-bar-container" />
            <div class="page-template-container">
              <nuxt />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <DefaultGuideLogin />
      </template>
    </template>
    <no-ssr>
      <OnlineService v-if="$store.state.locale === 'sg' || $store.state.locale === 'uk'" />
      <QiyuCustomerService v-if="$store.state.locale === 'us'" />
    </no-ssr>
    <CookiesStatement v-if="$store.state.locale === 'uk'" />

    <no-ssr>
      <!-- lesson reminder -->
      <ClassReminder />
      <!-- 登录及绑定邮箱弹窗 -->
      <LoginDialog :show.sync="showLoginDialog" :success-url="loginSuccessUrl" :trigger-src="loginTriggerSrc" :login-trigger-source="loginTriggerSource" :is-group="isGroup" />
      <BindEmailDialog :show.sync="showBindEmailDialog" :success-url="bindEmailSuccessUrl" :trigger-src="bindEmailTriggerSrc" />
      <CompleteStuInfoDialog ref="completeStuInfoDialog" :trigger-args="completeStuInfoTriggerArgs" />
      <UnpaidDialog ref="unpaidDialog" />
      <BindDialog />
      <AppointmentDiagnosis v-if="showDiagnosis" :show.sync="showDiagnosis" :diagnosis-info="diagnosisInfo" />
    </no-ssr>
  </div>
</template>

<script>
import bus from 'common/bus';
import headMixin from 'mixins/layout/head';
import Header from '@/components/global/FeatureComponents/Header/web';
import SideNavigationBar from 'components/common/SideNavigationBar';
import OnlineService from 'components/common/OnlineService/index.vue'
import QiyuCustomerService from '@/components/global/FeatureComponents/QiyuCustomerService/web.vue'
import LoginDialog from 'components/login/LoginDialog/index.vue';
import BindEmailDialog from 'components/login/BindEmailDialog/index.vue';
import CompleteStuInfoDialog from 'components/login/CompleteStuInfoDialog/index.vue';
import DefaultGuideLogin from 'components/common/DefaultGuideLogin/index.vue';
import Exception from 'components/common/Exception/index.vue';
import UnpaidDialog from 'components/common/UnpaidDialog/index.vue';
import CookiesStatement from 'components/common/CookiesStatement/index.vue';
import BindDialog from 'components/common/bindDialog/index.vue';
// import AppointmentDiagnosis from 'components/appointmentDiagnosis/index.vue';
import USHeader from '@/components/global/FeatureComponents/USHeader/web';
import NewUSHeader from '@/components/global/FeatureComponents/NewUsHeader/web'
import { getFaviconLink } from 'common/utils.js';
import ClassReminder from '@/components/global/FeatureComponents/ClassReminder/web';

const AppointmentDiagnosis = () => import('components/appointmentDiagnosis/index.vue');

export default {
  components: {
    Header,
    SideNavigationBar,
    OnlineService,
    QiyuCustomerService,
    LoginDialog,
    BindEmailDialog,
    CompleteStuInfoDialog,
    DefaultGuideLogin,
    Exception,
    UnpaidDialog,
    CookiesStatement,
    BindDialog,
    AppointmentDiagnosis,
    USHeader,
    NewUSHeader,
    ClassReminder,
  },
  mixins: [headMixin],
  data() {
    return {
      // 登录弹窗
      showLoginDialog: false,
      // 绑定邮箱弹窗
      showBindEmailDialog: false,
      // 完善学员信息弹窗
      showCompleteStuInfoDialog: false,
      loginSuccessUrl: '',
      loginTriggerSource: '',
      bindEmailSuccessUrl: '',
      loginTriggerSrc: '',
      bindEmailTriggerSrc: '',
      completeStuInfoTriggerArgs: null,
      isGroup: false,
      showDiagnosis: false,
      diagnosisInfo: {},
    }
  },
  computed: {
    /**
     * 当前语言环境样式名
     * 可通过此样式名叠加样式实现不同语言样式
     */
    localeClass() {
      return `locale__${this.$store.state.locale}`;
    },
    /**
     * 登录态
     */
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
    schoolCode() {
      return this.$store.state.schoolCode;
    },
    thinkType() {
      return this.$store.state.thinkType
    },
    isGray() {
      return (process.env.grayType || '').toLowerCase() === 'gray';
    },
    showUsHeader() {
      const schoolList = ['415', '8601', '105'];
      console.log('thinkType is ----', this.thinkType);
      // Show US Header if ((not gray && schoolCode is in list && thinkType is 'inperson') || (gray && schoolCode is in list))
      if ((!this.isGray && schoolList.includes(this.schoolCode))
        || (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'inperson')) {
        return true;
      }
      return false;
    },
    showNewUsHeader() {
      // us mars uk ca jp kr fr
      const schoolList = ['415', '8601', '4401', '103', '8101', '8201', '3301']
      console.log('thinkType is ----', this.thinkType)
      if (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'online') {
        return true;
      }
      return false;
    },
    isNewcomponentMlz() {
      return this.$route.path && (this.$route.path.includes('newcomponent-mlz') || this.$route.path.includes('prwalkthrough') || this.$route.path.includes('newfive') || this.$route.path === '/');
    },
  },
  watch: {
    isLogin(newVal) {
      if (!newVal) {
        this.login()
      }
    },
  },
  mounted() {
    // 页面刷新强制跳转到页面顶部
    document.documentElement.scrollTop = 0;

    if (!this.isLogin) this.login()
    // 登录弹窗
    bus.$on('login', (argsObj) => {
      if (argsObj && argsObj.triggerSrc) {
        this.loginTriggerSrc = argsObj.triggerSrc;
      }
      if (argsObj && argsObj.triggerSource) {
        this.loginTriggerSource = argsObj.triggerSource
      }
      if (argsObj && argsObj.successUrl) {
        this.loginSuccessUrl = argsObj.successUrl;
      }
      if (argsObj && argsObj.isGroup) {
        this.isGroup = argsObj.isGroup;
      }
      this.login();
    });

    // 预约诊断弹窗
    bus.$on('toShowDiagnosis', (argsObj) => {
      console.log('进3')
      this.toShowDiagnosis(argsObj);
    });

    this.$nextTick(() => {
      // 完善学员信息弹窗
      bus.$on('complete-stu-info', (argsObj) => {
        if (argsObj) this.completeStuInfoTriggerArgs = argsObj;
        this.completeStuInfo(argsObj);
      });
      // 续报提醒弹窗
      bus.$on('openUnpaidDialog', () => {
        this.openUnpaidDialog();
      });
    })
  },
  destroyed() {
    // 页面销毁的时候取消监听
    bus.$off('login')
    bus.$off('toShowDiagnosis')
    bus.$off('complete-stu-info')
    bus.$off('openUnpaidDialog')
  },
  methods: {
    login() {
      this.showLoginDialog = true;
    },
    toShowDiagnosis(argsObj) {
      this.diagnosisInfo = argsObj || {}
      this.showDiagnosis = true
    },
    bindEmail() {
      this.showBindEmailDialog = true;
    },
    completeStuInfo(argsObj) {
      if (this.$refs.completeStuInfoDialog) this.$refs.completeStuInfoDialog.openDialog(argsObj);
    },
    reload() {
      if (this.$nuxt.isOffline) return;
      window.location.reload();
    },
    openUnpaidDialog() {
      if (this.$refs.unpaidDialog) this.$refs.unpaidDialog.openDialog();
    },
  },
  head() {
    const betterme = this.$store.state.betterme === 'bettermeedu' ? 'bettermeedu' : 'default';
    return {
      ...headMixin.head.call(this),
      htmlAttrs: {
        id: `style__${this.$store.state.betterme}`,
      },
      link: getFaviconLink(betterme),
    }
  },
}
</script>

<style lang="scss" scoped>
.personal-center-body-wrapper {
  height: 100%;
  padding: 40px 0 79px;
  background: #fff;

  .side-nav-bar-container {
    margin-right: 24px;
  }

  .page-template-container {
    position: relative;
    width: 878px;
    min-height: 100%;
    background: #fafafa;
    border-radius: 8px;
    overflow: hidden;
  }
}
</style>
